export const COST_GENERATOR_REPEAT_NO = 1
export const COST_GENERATOR_REPEAT_WEEK = 2
export const COST_GENERATOR_REPEAT_MONTH = 3
export const COST_GENERATOR_REPEAT_QUARTER = 4
export const COST_GENERATOR_REPEAT_HALF = 5
export const COST_GENERATOR_REPEAT_YEAR = 6

export const COST_GENERATOR_REPEATS = [
    {
        id: COST_GENERATOR_REPEAT_NO,
        name: 'period.1',
    },
    {
        id: COST_GENERATOR_REPEAT_WEEK,
        name: 'period.2',
    },
    {
        id: COST_GENERATOR_REPEAT_MONTH,
        name: 'period.3',
    },
    {
        id: COST_GENERATOR_REPEAT_QUARTER,
        name: 'period.4',
    },
    {
        id: COST_GENERATOR_REPEAT_HALF,
        name: 'period.5',
    },
    {
        id: COST_GENERATOR_REPEAT_YEAR,
        name: 'period.6',
    },
]
